import { track } from '@vercel/analytics';
import { outboundLinks } from '~/shared/outbound-links';

export const Component = () => {
  return (
    <>
      <a
        href={outboundLinks.bigHorn.root + outboundLinks.bigHorn.evoos}
        rel="noopener"
        onClick={() => track('bhooc-ad-interstitial')}
      >
        <div className="px-4 py-2 mr-2 mb-8 font-semibold text-white bg-yellow-600 rounded-md shadow-md flex items-center">
          <div className="flex-grow">
            <p className="font-bold mb-1 text-lg italic">Rediscover the joy of eating!...</p>
            <p className="px-4">...with award-winning, fresh harvest, extra virgin olive oil.</p>
            <p className="mt-8">
              <span className="p-4 bg-green-800 rounded-full shadow-md uppercase hidden sm:inline-block">Click here to shop</span>
              <span className="p-4 bg-green-800 rounded-full shadow-md uppercase md:hidden">Shop now</span>
            </p>
          </div>
          <img 
            src="/images/A7402766-sm.webp" 
            alt="" 
            className="ml-4 max-w-[120px] max-h-[120px] w-auto h-auto object-contain rounded-md border-2 border-white shadow-lg"
          />
        </div>
      </a>
    </>
  );
};
